<template lang="html">
  <div class="ending"
  :class="{
    'hide': scrollProgress<13
    }"
  >

    <div class="exit cursor-pointer absolute inset-0 z-10" @click="exit">

    </div>

    <div
    class="w-full mx-auto max-w-screen-md w-full lg:w-1/2 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50"
    >
      <div class="pb-3/4 w-full relative">
        <div class="absolute inset-0">
          <iframe
          class="w-full h-full"
          :src="src"
          width="" height=""
          >
          </iframe>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
// import marked from 'marked'
// import {pythagorean} from '@/common/util.js'
// import {contents} from '@/common/content.js'
// import Flickity from 'vue-flickity';
import {gsap} from 'gsap'
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);
export default {
  // components: {
  //   Flickity
  // },

  data() {
    return {
      src: ''
    }
  },

  computed: {
    scrollProgress () {
      return this.$store.state.scrollProgress
    },
    sceneProgress () {
      return this.$store.state.sceneProgress
    }
  },

  watch: {
    'scrollProgress' (newVal, oldVal) {
      this.onScrollProgressChange(newVal)
    },
    'sceneProgress' (newVal, oldVal) {
      this.onSceneProgressChange(newVal)
    }
  },

  methods: {

    exit () {
      gsap.to(window, {duration: 1, scrollTo: `#scroll-content-12`});
    },
    // markdown (string) {
    //   return marked(string)
    // },
    onScrollProgressChange (newVal) {
      // this.select(newVal)
      console.log('ending. this.scrollProgress: ', newVal)
      if (newVal==13&&!this.src) {
        this.src = 'https://www.youtube.com/embed/buqtdpuZxvk?autoplay=1&modestbranding=1&playsinline=1&loop=1'
      }
    },

    onSceneProgressChange (newVal) {

    },

  }
}
</script>

<style lang="scss">
.ending {
  @apply fixed pointer-events-auto w-full h-full inset-0;
  @apply transition duration-700 ease-in-out;
  z-index:9999;

  @apply bg-black bg-opacity-80;

  opacity: 1;
  // transform:translate(-50%, -50%);
  @screen md {
    // transform:translate(-50%, -50%);
  }

  &.hide {
    @apply pointer-events-none;
    opacity: 0;
    // transform:translate(-50%, 0);
    @screen md {
      // transform:translate(-50%, 0);
    }
  }
}
</style>
